
window.$ = window.jQuery = require('jquery');
require('./web_function')
require('./jquery_visible')
require('./finaltilesgallery/jquery.finaltilesgallery')

import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'
import {Draggable} from 'gsap/Draggable'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

window.gsap           = gsap;
window.ScrollTrigger  = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.Draggable = Draggable;

import Swiper, { Navigation, Pagination, Grid } from 'swiper'
window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;
window.Grid = Grid;

import 'jquery-validation';
require('./validation_helper')

import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
window.Swal = Swal;

import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
window.THREE = THREE;
window.OrbitControls = OrbitControls;

import * as dat from 'dat.gui';
window.dat = dat;

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});
